import TitleBar from './title-bar';
import Toolbar from './toolbar';
import ToolboxSidebar from './toolbox-sidebar';
import SolutionExplorer from './solution-explorer';
import StatusBar from './status-bar';

/**
 * Shared IDE chrome wrapper for Remotion scene components.
 * Children go in the editor+output area. overlay renders on top (e.g. ConsoleWindow).
 */
export default function IdeShell({
  projectName = 'HelloWorld',
  filename = 'Program.cs',
  step = 0,
  lineCount = 1,
  col = 1,
  children,
  overlay,
}) {
  return (
    <div className="flex flex-col h-full w-full bg-[#1e1e1e] text-[#cccccc] select-none overflow-hidden"
         style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <TitleBar projectName={projectName} />
      <Toolbar step={step} projectName={projectName} />
      <div className="flex flex-1 overflow-hidden">
        <ToolboxSidebar />
        <div className="flex flex-col flex-1 overflow-hidden min-w-0">
          {children}
        </div>
        <SolutionExplorer projectName={projectName} filename={filename} />
      </div>
      <StatusBar step={step} lineCount={lineCount} col={col} />
      {overlay}
    </div>
  );
}
